export type IFsLprReadsSort =
  | 'event_timestamp'
  | '-event_timestamp'
  | 'plate'
  | '-plate'
  | 'camera_name'
  | '-camera_name';

export enum IFsLprReadsProvider {
  ALPR_WEB = 'ALPR_WEB',
  ALTUMINT = 'ALTUMINT',
  AXON_FLEET = 'AXON_FLEET',
  BLUE_LINE = 'BLUE_LINE',
  BOSCH = 'BOSCH',
  EAGLE_EYE_NETWORKS = 'EAGLE_EYE_NETWORKS',
  ELSAG = 'ELSAG',
  EPIC_IO = 'EPIC_IO',
  FFGROUP = 'FFGROUP',
  FLOCK_SAFETY = 'FLOCK_SAFETY',
  FUSUS = 'FUSUS',
  GENETEC = 'GENETEC',
  GENETEC_SHARP3 = 'GENETEC_SHARP3',
  GENETEC_SHARP5 = 'GENETEC_SHARP5',
  GEOVISION = 'GEOVISION',
  INSIGHT_LPR = 'INSIGHT_LPR',
  LOGIQ = 'LOGIQ',
  MILESTONE = 'MILESTONE',
  MINUTEMAN = 'MINUTEMAN',
  NDI = 'NDI',
  OPENALPR = 'OPENALPR',
  REKOR = 'REKOR',
  RHOMBUS = 'RHOMBUS',
  SKYCOP = 'SKYCOP',
  VAXTOR = 'VAXTOR',
  VERKADA = 'VERKADA',
  VIGILANT = 'VIGILANT',
  WATCHMAN = 'WATCHMAN',
  WOLFCOM = 'WOLFCOM',
}

/**
 * Interface for LPR Reads search parameters (Fusus/LPR Ingest).
 *
 * Backend:
 * - Path: lpr-ingest/layers/common/python/common/reads/__init__.py (`lpr-ingest` on BitBucket)
 * - Class: ReadQueryParameters
 */
export interface IFsLprReadsParameters {
  search_reason: string;
  case_number?: string;
  /** Plate to search. Wildcards allowed */
  plate?: string;
  plate_state?: string;
  /** CSV list of cameras (array of uuids) to filter results */
  camera?: string[];
  is_hit?: boolean;
  event_timestamp_from?: string;
  event_timestamp_to?: string;
  /** Datetime period representing the period of time */
  period?: string;
  vehicle_color?: string[];
  vehicle_make?: string[];
  vehicle_model?: string[];
  vehicle_body_type?: string[];
  polygon?: string;
  bbox?: string;
  point?: string;
  provider?: IFsLprReadsProvider;
  ordering?: IFsLprReadsSort;
  force_offline?: boolean;
  page?: number;
  /** defaults to 50 */
  size?: number;
}
